import "slick-carousel";

import '../styles/sites78-82/style.scss';
import "./cookie";
import {unsubscribeLogic} from "./unsubscribe";
import {paymentLogic} from "./paymentPagesLogic";
import {scrollLogic} from "./scrollLogic";
import {loginPageLogic} from "./login";
import {contactFormLogic} from "./contactForm";
import "./tw-elements/faq";
import "./tw-elements/header";
import "./elements/header";
import {useCountersSync} from "./counters";
import {pricingSwitchersLogic} from "./elements/pricingSwitchersLogic";
import customSliderButtons from "./elements/customSliderButtons";
import animateLettersColor from "./elements/animateLettersColor";
import animateDivs from "./elements/animateDivs";
import "./elements/linkEffect2LinesHover";
import "./elements/pinnedScroll";
import stickyRevealHeader from "./elements/stickyRevealHeader";
import runSlickSliders from "./elements/slickSliders";
import {initPageLoaderAndAnimations} from "./sites78-82/gsapLoader";

document.addEventListener("DOMContentLoaded", () => {

  useCountersSync(".counters-container");
  pricingSwitchersLogic();
  scrollLogic(0);
  unsubscribeLogic();
  paymentLogic();
  loginPageLogic();
  contactFormLogic();
  customSliderButtons();
  animateLettersColor();
  animateDivs();
  stickyRevealHeader();
  runSlickSliders();
  initPageLoaderAndAnimations();

  console.log('Common script is loaded');
});
